<template>
  <div class="exchange-submit-btn-component">
    <span class="exchange-tip">{{ receiveTips }}</span>
    <div class="submit-btn"
         :class="{'can-give': receiveStatus === 'canGive',
                  'disabled': receiveStatus === 'disabled'}"
    >
      <ym-button size="large"
                 round
                 :disabled="submitBtnDisabled || loopCount > 0"
                 @click="handleSubmit"
      >
        {{ submitText }}
      </ym-button>
    </div>
    <div class="term-tip"
         v-if="receiveStatus === 'canReceive'"
    >
      点击马上领取表示您已阅读并同意
      <router-link class="link"
                   :to="{ name: 'UserTerm' }"
      >
        服务协议
      </router-link>
    </div>
    <share-mask :show.sync="showShareMask"
                :share-path="sharePath"
                message="请复制下方链接，前往粘贴给好友"
    />
  </div>
</template>

<script>
  import { Button } from '@ymba/ym-ui';
  import { receiveCouponJoin } from '@/services/coupon';
  import ShareMask from '@/components/ShareMask';

  export default {
    name: 'CouponReceiveSubmitBtn',
    components: {
      'ym-button': Button,
      ShareMask,
    },
    data() {
      return {
        showShareMask: false,
        hasToAccount: false,
        loopCount: 0,
        loading: null,
      };
    },
    props: {
      receiveTips: {
        type: String,
        required: true,
      },
      receiveStatus: {
        type: String,
        required: true,
      },
      submitText: {
        type: String,
        required: true,
      },
      submitBtnDisabled: {
        type: Boolean,
        required: true,
      },
      id: {
        type: [String, Number],
        required: true,
      },
      code: {
        type: [String, Number],
        required: true,
        default: '',
      },
      mobile: {
        type: String,
        required: true,
      },
      smsCode: {
        type: String,
        required: true,
      },
      sharePath: {
        type: String,
      },
    },
    watch: {
      loopCount() {
        if (this.hasToAccount) {
          this.loading.clear();
          this.$router.push({ name: 'MyCoupon' });
        } else {
          this.handleJoin();
        }
      },
    },
    methods: {
      async handleJoin() {
        const data = await receiveCouponJoin(this.code, this.id, this.mobile, this.smsCode);
        this.hasToAccount = data.hasToAccount;
        setTimeout(() => {
          this.loopCount += 1;
        }, 1000);
      },
      handlePollLoop() {
        this.loading = this.$toast.loading({ duration: -1 });
        this.handleJoin();
      },
      async handleSubmit() {
        if (this.receiveStatus === 'canReceive') {
          this.handlePollLoop();
          return;
        }
        if (this.receiveStatus === 'disabled') {
          // 不是member并且产品不可加入
          this.$router.push({ name: 'MyCoupon' });
        }
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .exchange-submit-btn-component {
    margin-top: @size-large;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .exchange-tip {
    margin-bottom: @size-small;
    color: @color-text-lighter;
    font-size: @font-size-base;
  }

  .submit-btn {
    width: 630px;
    /deep/ button.is-disabled {
      background: rgba(204, 204, 204, 1);
      opacity: 1;
      color: @color-white;
    }
    /deep/ button {
      color: @color-white;
      background: linear-gradient(
        to left,
        @color-gradient-highlight-1,
        @color-gradient-highlight-2
      );
    }
    &.disabled {
      /deep/ button {
        color: @color-white;
        background: #ccc;
        box-shadow: none;
      }
    }
  }

  .term-tip {
    margin-top: @size-base;
    color: @color-text-lighter;
    font-size: @font-size-small;
    .link {
      color: @color-link;
    }
  }

</style>
